import React, { FC, ReactElement } from 'react';
import withLocalization from '../hoc/withLocalization';
import '../OfferContactInformation/ContactInformationHeader.scss';

const ConfirmationHeader: FC<any> = (props: any): ReactElement => {
  const { localize, confirmationNumber } = props;
  const confirmationMessage = confirmationNumber
    ? `${localize(
        'preview-sales-engine.static-content.copy.After Payment Page.package-confirmation',
      )} ${confirmationNumber}`
    : '';
  return (
    <>
      {confirmationNumber && (
        <div className="dateHeaderWrapper">
          <h3 className="headBaskerville">
            {localize('preview-sales-engine.static-content.copy.After Payment Page.thank-you')}
          </h3>
          <p>{confirmationMessage}</p>
        </div>
      )}
    </>
  );
};
export default withLocalization(ConfirmationHeader);
